import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap';

import { RootState, getCurrentUser } from '../../store';
import { User } from '../../store/types';
import { UserRoles } from '../../utils/utils';
import { ILocalization } from '../../localization/definitions/types';
import HelpTipsList from './helpTipsList/HelpTipsList';
import HelpDocumentsList from './HelpDocumentsList';
import { getAdminDocumentsByUserRole } from '../../store/actions/AdminActions';
import {
    AdminDocumentDisplayOnEnum,
    IAdminDocument,
} from '../admin/supervisors/interfaces';
import SupervisorTutorialModal from '../thesisManagement/tutorial/SupervisorTutorialModal';
import UserTutorialModal from '../thesisManagement/tutorial/UserTutorialModal';
import { HeaderWithBackButton } from '../shared/headerWithBackButton/HeaderWithBackButton';
import { HelpTabs } from '../admin/adminTabDefinitions';
import { SusyTabs } from '../shared/tabs/SusyTabs';

import './../thesisManagement/ThesisOverview.css';

interface HelpProps {
    getCurrentUser: () => Promise<void>;
    currentUser: User | null;
    localization: ILocalization;
    backLink?: string;
    adminDocuments: Array<IAdminDocument>;
    getAdminDocumentsByUserRole: () => Promise<void>;
}

interface HelpStates {
    activeTab: string;
}

class Help extends React.Component<HelpProps, HelpStates> {
    state = { activeTab: HelpTabs.Tips };

    componentDidMount = async () => {
        if (!this.props.currentUser) {
            await this.props.getCurrentUser();
        }
        await this.props.getAdminDocumentsByUserRole();
    };

    render() {
        const localization =
            this.props.localization.localizationStrings.susy.help.help;
        return (
            <div>
                <HeaderWithBackButton
                    headerTitle={localization.helpTitle}
                    pathname={this.props.backLink}
                />
                <div className='susy-page-content-wrapper'>
                    <SusyTabs
                        rootNavigation='/help'
                        tabs={[
                            {
                                tabHeader: localization.tabThesisProcessTips,
                                tabName: HelpTabs.Tips,
                                content: (
                                    <HelpTipsList
                                        userRole={
                                            this.props.currentUser?.userRole
                                        }
                                    />
                                ),
                            },
                            {
                                tabHeader: localization.tabDocuments,
                                tabName: HelpTabs.Documents,
                                content: (
                                    <HelpDocumentsList
                                        userRole={
                                            this.props.currentUser?.userRole
                                        }
                                        adminDocuments={this.props.adminDocuments.filter(
                                            (adminDocument) =>
                                                adminDocument.displayOn.includes(
                                                    AdminDocumentDisplayOnEnum.HelpPage
                                                )
                                        )}
                                    />
                                ),
                            },
                        ]}
                    />
                </div>

                {this.props.currentUser?.userRole.key ===
                    UserRoles.supervisor && (
                    <SupervisorTutorialModal
                        initialOpen={
                            this.props.currentUser?.firstTimeLogin || false
                        }
                    />
                )}

                {this.props.currentUser?.userRole.key === UserRoles.user && (
                    <UserTutorialModal
                        initialOpen={
                            this.props.currentUser?.firstTimeLogin || false
                        }
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        currentUser: state.auth.currentUser,
        adminDocuments: state.adminDocuments,
        localization: state.localization,
    };
};

export default connect(mapStateToProps, {
    getAdminDocumentsByUserRole,
    getCurrentUser,
})(Help);
